export default "__VITE_ASSET__f114c813__"